/* C1 run outcome (Full Service revamp, 2026-10-02): what a FINISHED run amounted to, decided once at finalize from the
   executor's own record and stored at workflow_run.meta.workflowRunSummary.outcome. `status` stays the lifecycle value;
   a run whose tolerated failures were not marked expected finishes `succeeded` with outcome `completed_with_failures`.
   Every surface reads this value; none re-derives it. Runs finalized before it existed carry no outcome. */
export const PIEVE_WORKFLOW_RUN_OUTCOME = Object.freeze({
  clean: 'clean',
  completedWithFailures: 'completed_with_failures',
  failed: 'failed',
  canceled: 'canceled'
});
